<template>
  <div class="gap-10 pb-10 pt-10 d-flex position-relative" style="max-height: 600px; min-height: 600px">
    <BaseLoader v-if="loadingsStateComponent.main"></BaseLoader>
    <div style="width: 402px; height: 555px">
      <div class="system-block position-relative px-15 pt-5 pb-10 h-100 text-muted">
        <div v-if="!loadingsStateComponent.main">
          <div class="fsc-11 d-flex justify-content-between mb-5" style="padding-top: 8px">
            <div class="d-flex justify-content-between align-items-center gap-10 text-muted">
              <div style="width: 120px">Активный реферер</div>
              <div style="">{{ dataForTab?.companies__referer_id }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-10">
              <span style="white-space: nowrap;">Кф. реф.</span>

              <BaseInputNew placeholder="" width="56" class="wp-100" input-name="companies__referer_koef"
                @input="updateValue" inputClass="" :horizontalTitle="true" ref="companies__referer_koef"
                :value="dataForTab?.companies__referer_koef" inputRef="companies__referer_koef" inputMask="0.00"
                :additionalParams="{}" name-sign="">
              </BaseInputNew>
            </div>
          </div>
          <div>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5" input-name="cities__name" @input="" disabled
              inputClass="text-muted" :horizontalTitle="true" ref="cities__name" :value="dataForTab?.regions__name"
              :additionalParams="{}" :name-sign="dataLang['reg_company_59']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" disabled class="wp-100" input-name="cities__name" @input=""
              inputClass="text-muted" :horizontalTitle="true" ref="cities__name" :value="dataForTab?.cities__name"
              :additionalParams="{}" :name-sign="dataLang['reg_company_60']">
            </BaseInputNew>
          </div>
          <div class="fsc-12 fw-bold my-5">
            {{ dataLang['reg_company_61'] }}
          </div>
          <div>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5"
              input-name="company_settings__set_req_company_name" @input="" disabled inputClass="text-muted"
              :horizontalTitle="true" ref="company_settings__set_req_company_name"
              :value="dataForTab?.company_settings__set_req_company_name" :additionalParams="{}"
              :name-sign="dataLang['reg_company_62']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" disabled class="wp-100 mb-5"
              input-name="company_settings__set_req_inn" @input="" inputClass="text-muted" :horizontalTitle="true"
              ref="company_settings__set_req_inn" :value="dataForTab?.company_settings__set_req_inn"
              :additionalParams="{}" :name-sign="dataLang['reg_company_16']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5" input-name="company_settings__set_req_ogrn"
              @input="" disabled inputClass="text-muted" :horizontalTitle="true" ref="company_settings__set_req_ogrn"
              :value="dataForTab?.company_settings__set_req_ogrn" :additionalParams="{}"
              :name-sign="dataLang['reg_company_63']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5"
              input-name="company_settings__set_req_address_ur" @input="" disabled inputClass="text-muted"
              :horizontalTitle="true" ref="company_settings__set_req_address_ur"
              :value="dataForTab?.company_settings__set_req_address_ur" :additionalParams="{}"
              :name-sign="dataLang['reg_company_64']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5"
              input-name="company_settings__set_req_address_fact" @input="" disabled inputClass="text-muted"
              :horizontalTitle="true" ref="company_settings__set_req_address_fact"
              :value="dataForTab?.company_settings__set_req_address_fact" :additionalParams="{}"
              :name-sign="dataLang['reg_company_65']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5" input-name="company_settings__set_req_gen_dir"
              @input="" disabled inputClass="text-muted" :horizontalTitle="true" ref="company_settings__set_req_gen_dir"
              :value="dataForTab?.company_settings__set_req_gen_dir" :additionalParams="{}"
              :name-sign="dataLang['reg_company_66']">
            </BaseInputNew>
          </div>
          <div class="fsc-12 fw-bold my-5">
            {{ dataLang['reg_company_67'] }}
          </div>
          <div>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5" input-name="company_settings__set_req_rs"
              @input="" disabled inputClass="text-muted" :horizontalTitle="true" ref="company_settings__set_req_rs"
              :value="dataForTab?.company_settings__set_req_rs" :additionalParams="{}"
              :name-sign="dataLang['reg_company_35']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" disabled class="wp-100 mb-5"
              input-name="company_settings__set_req_bank" @input="" inputClass="text-muted" :horizontalTitle="true"
              ref="company_settings__set_req_bank" :value="dataForTab?.company_settings__set_req_bank"
              :additionalParams="{}" :name-sign="dataLang['reg_company_68']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5" input-name="company_settings__set_req_bik"
              @input="" disabled inputClass="text-muted" :horizontalTitle="true" ref="company_settings__set_req_bik"
              :value="dataForTab?.company_settings__set_req_bik" :additionalParams="{}"
              :name-sign="dataLang['reg_company_34']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" class="wp-100" input-name="company_settings__set_req_ks" @input=""
              disabled inputClass="text-muted" :horizontalTitle="true" ref="company_settings__set_req_ks"
              :value="dataForTab?.company_settings__set_req_ks" :additionalParams="{}"
              :name-sign="dataLang['reg_company_69']">
            </BaseInputNew>
          </div>

          <div class="fsc-12 fw-bold my-5">
            {{ dataLang['reg_company_70'] }}
          </div>
          <div>
            <BaseInputNew placeholder="" width="252" class="wp-100 mb-5" input-name="company_settings__set_req_phone"
              @input="" disabled inputClass="text-muted" :horizontalTitle="true" ref="company_settings__set_req_phone"
              :value="dataForTab?.company_settings__set_req_phone" :additionalParams="{}"
              :name-sign="dataLang['reg_company_71']">
            </BaseInputNew>
            <BaseInputNew placeholder="" width="252" disabled class="wp-100"
              input-name="company_settings__set_req_email" @input="" inputClass="text-muted" :horizontalTitle="true"
              ref="company_settings__set_req_email" :value="dataForTab?.company_settings__set_req_email"
              :additionalParams="{}" :name-sign="dataLang['reg_company_72']">
            </BaseInputNew>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 402px; height: 555px">
      <div class="system-block position-relative pb-5 px-0 pt-0 h-100 overflow-visible">
        <div v-if="!loadingsStateComponent.main">
          <div class="px-15 pt-5">
            <div class="fsc-12 fw-bold">
              {{ dataLang['reg_company_6'] }}
            </div>
            <div class="py-15 text-center text-white fsc-14 mb-5" :style="{
              'background-color':
                tabInfo.data?.companies__balance > -1 ? '#23B14D' : '#FF2400'
            }">
              {{ tabInfo.data?.companies__balance.split('.').join(',') }}
            </div>
            <div class="fsc-12 fw-bold mb-5">
              {{ dataLang['reg_company_73'] }}
            </div>
          </div>
          <div class="fsc-11">
            <div class="bg-system-secondary d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_74'] }}</div>
              <div>
                {{
                  $time(tabInfo.data?.companies__created_at).format(
                    'DD.MM.YYYY'
                  )
                }}
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_75'] }}</div>
              <div>{{ tabInfo.data?.employees__name }}</div>
            </div>

            <div class="bg-system-secondary d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_71'] }}</div>
              <div>
                {{ tabInfo.data?.employees__phone }}
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_76'] }}</div>
              <a class="text-decoration-underline" :href="`mailto:${tabInfo.data?.employees__email}`">{{
                tabInfo.data?.employees__email }}</a>
            </div>

            <div class="bg-system-secondary d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_77'] }}</div>
              <div>
                {{
                  $time(tabInfo.data?.employees__last_login_at).format(
                    'DD.MM.YYYY'
                  )
                }}
              </div>
            </div>
          </div>
          <div class="fsc-11 mt-5">
            <div class="fsc-12 fw-bold mb-5 px-15">
              {{ dataLang['reg_company_78'] }}
            </div>
            <div class="bg-system-secondary d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_79'] }}</div>
              <div>
                {{ tabInfo.data?.companies__employee_count }}
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_80'] }}</div>
              <div>{{ tabInfo.data?.companies__place_count }}</div>
            </div>

            <div class="bg-system-secondary d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_81'] }}</div>
              <div>
                {{ tabInfo.data?.companies__object_count }}
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center py-5 px-15">
              <div>{{ dataLang['reg_company_82'] }}</div>
              <div>
                {{
                  tabInfo.data?.companies__balance_count.split('.').join(',')
                }}
              </div>
            </div>
          </div>
          <div class="mt-5">
            <div class="fsc-12 fw-bold mb-5 px-15">
              {{ dataLang['reg_company_83'] }}
            </div>
          </div>
          <div class="mb-5 wp-100 d-flex justify-content-between align-items-center px-15" ref="companies__status">
            <BaseSelect class="position-relative" style="z-index: 2" @input="
              (data) =>
                updateValue({ name: 'companies__status', value: data.value })
            " placeholder="" selectLabel="" deselectLabel="" v-model="companiesStatus"
              :custom-label="({ label }) => label" :options="listOptionsStatus" :maxHeight="165" openDirection="bottom">
              <template slot="noOptions">{{
                dataLang['select_empty']
                }}</template>
              <template slot="noResult">{{
                dataLang['select_search_empty']
                }}</template>
              <template slot="selectedLabel">{{
                dataLang['select_selected']
                }}</template>
              <template slot="deselectLabel">{{
                dataLang['select_unselect']
                }}</template>
            </BaseSelect>
          </div>
          <div class="mb-5 wp-100 d-flex justify-content-between align-items-center px-15"
            ref="companies__is_place_any_city">
            <span class="fsc-11 text-muted input-title">
              {{ dataLang['reg_company_84'] }}
            </span>
            <BaseSelect class="position-relative" style="z-index: 1; width: 240px" @input="
              (data) =>
                updateValue({
                  name: 'companies__is_place_any_city',
                  value: data.value
                })
            " placeholder="" selectLabel="" deselectLabel="" v-model="companiesPlaces"
              :custom-label="({ label }) => label" :options="listOptionsPlaces" :maxHeight="165" openDirection="bottom">
              <template slot="noOptions">{{
                dataLang['select_empty']
                }}</template>
              <template slot="noResult">{{
                dataLang['select_search_empty']
                }}</template>
              <template slot="selectedLabel">{{
                dataLang['select_selected']
                }}</template>
              <template slot="deselectLabel">{{
                dataLang['select_unselect']
                }}</template>
            </BaseSelect>
          </div>

          <div class="px-15">
            <BaseInputNew placeholder="" width="180" class="wp-100 mb-5" input-name="companies__place_priority"
              @input="updateValue" inputClass="" :horizontalTitle="true" :value="tabInfo.data.companies__place_priority"
              :additionalParams="{}" :name-sign="dataLang['reg_company_85']">
            </BaseInputNew>
          </div>
          <div class="fsc-12 fw-bold px-15">
            {{ dataLang['reg_company_86'] }}
          </div>
          <div class="d-flex gap-5 px-15">
            <BaseInputNew placeholder="" width="100%" class="lh-1 flex-grow-1" input-name="someSmsToSend"
              maxLength="500" @input="
                ({ value }) => (senderSmsPreset.sms_presets__text = value)
              " :horizontalTitle="true" signClass="text-dark" inputClass="" :additionalParams="{}" name-sign=""
              :value="senderSmsPreset.sms_presets__text">
            </BaseInputNew>
            <div class="base-button base-button--action" style="min-height: 26px" @click="sendSmsSome">
              <span class="fsc-11">{{ dataLang['reg_company_87'] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 402px; height: 555px">
      <div class="system-block h-100 position-relative px-15 pt-5 pb-10">
        <BaseLoader v-if="loadingsStateComponent.comment"></BaseLoader>
        <div class="fsc-11 fw-bold">
          {{ dataLang['vehicles_page__modal__tab_comments__name'] }}
        </div>
        <div class="d-flex gap-10 mt-15 mb-10">
          <BaseInputNew placeholder="" width="100%" class="wp-100" input-name="text"
            @input="(data) => (newCommentValue = data)" :horizontalTitle="true" ref="text" value=""
            :additionalParams="{}" name-sign="">
          </BaseInputNew>
          <div class="base-button base-button--action px-5 py-5" style="min-height: 26px; height: 26px"
            @click="sendComment">
            <img :src="require(`@/assets/icons/add.svg`)" width="12" height="12" />
          </div>
        </div>
        <BaseScrollbar style="max-height: 470px">
          <div class="comments">
            <div class="comments-base d-flex flex-column gap-10">
              <!-- {
      "client_comments__client_id": 2,
      "client_comments__comment": "Автокомментарий. Установлено новое время для перезвона - 2024-04-12 22:50:13",
      "client_comments__company_id": 51,
      "client_comments__created_at": "2024-04-12 14:50:13",
      "client_comments__employee_id": 59,
      "client_comments__id": 5,
      "client_comments__is_fixed": 0,
      "client_comments__updated_at": "2024-04-12 14:50:13"
  } -->
              <div v-for="(comment, index) of commentsList" :key="comment.company_comments__id"
                class="comment d-flex gap-5 justify-content-between border border-1 border-disabled">
                <div class="comment-info d-flex flex-column gap-0">
                  <p class="comment-info__heading text-black fw-normal fsc-11 lh-sm m-0">
                    {{
                      $time(comment.company_comments__created_at)
                        .utc(true)
                        .utcOffset(Number(userSetting.company__utc))
                        .format(`${userSetting.company__tempalte_date} HH:mm`)
                    }}
                  </p>
                  <p class="comment-info__content text-black fw-medium fsc-12 lh-sm m-0">
                    {{ comment.company_comments__comment }}
                  </p>
                </div>

                <div class="comment-actions d-flex h-100">
                  <div :class="[]"
                    class="comment-actions__pin d-flex justify-content-center align-items-center rounded-5 cursor-pointer"
                    @click="
                      () => {
                        fixComment(
                          comment.company_comments__id,
                          !comment.company_comments__is_fixed
                        )
                        comment.company_comments__is_fixed =
                          !comment.company_comments__is_fixed
                      }
                    ">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" :fill="[
                        comment.company_comments__is_fixed
                          ? '#23B14D'
                          : 'rgba(49, 48, 61, 1)'
                      ]"
                        d="M10.6749 2.22974L14.2316 5.69537C14.2787 5.74122 14.312 5.7958 14.3316 5.85402L14.5475 6.06994C14.7064 6.22889 14.7064 6.48659 14.5475 6.64554L12.2451 8.94794C12.0861 9.10689 11.8284 9.10689 11.6695 8.94794L11.0939 8.37234C11.0409 8.31936 10.955 8.31936 10.902 8.37234L10.6566 8.61779C10.574 8.70037 10.5535 8.82654 10.6058 8.931L11.3464 10.4124C11.4248 10.5691 11.3941 10.7583 11.2702 10.8822L9.36709 12.7853C9.20814 12.9442 8.95044 12.9442 8.79149 12.7853L6.68096 10.6747L2.41192 14.9438C2.25297 15.1027 1.99527 15.1027 1.83632 14.9438L1.45258 14.56C1.29364 14.4011 1.29364 14.1434 1.45258 13.9844L5.72162 9.71541L3.61109 7.60488C3.45214 7.44593 3.45214 7.18822 3.61109 7.02928L5.51419 5.12617C5.63807 5.0023 5.82731 4.97159 5.98401 5.04993L7.46537 5.79061C7.56983 5.84284 7.696 5.82237 7.77858 5.73978L8.02402 5.49434C8.07701 5.44136 8.07701 5.35546 8.02402 5.30247L7.44842 4.72687C7.28948 4.56793 7.28948 4.31022 7.44842 4.15127L9.75083 1.84887C9.90977 1.68992 10.1675 1.68992 10.3264 1.84887L10.5746 2.09704C10.615 2.13744 10.6484 2.18218 10.6749 2.22974ZM12.9412 6.33209L10.0269 3.49247L9.27116 4.24721C9.16519 4.35317 9.16519 4.52498 9.27116 4.63094L9.84676 5.20654C9.95273 5.31251 9.95273 5.48431 9.84676 5.59027L7.83216 7.60488C7.72619 7.71084 7.55439 7.71084 7.44842 7.60488L6.86777 7.02422C6.84715 7.0036 6.82334 6.98644 6.79725 6.9734L6.16443 6.65699C6.05997 6.60475 5.9338 6.62523 5.85122 6.70781L5.43382 7.12521C5.32786 7.23117 5.32786 7.40298 5.43382 7.50894L8.88743 10.9625C8.99339 11.0685 9.16519 11.0685 9.27116 10.9625L9.68855 10.5452C9.77114 10.4626 9.79161 10.3364 9.73938 10.2319L9.42297 9.59912C9.40993 9.57303 9.39277 9.54922 9.37214 9.5286L8.79149 8.94794C8.68553 8.84198 8.68553 8.67018 8.79149 8.56421L10.8061 6.54961C10.9121 6.44364 11.0839 6.44364 11.1898 6.54961L11.7654 7.12521C11.8714 7.23117 12.0432 7.23117 12.1492 7.12521L12.9412 6.33209Z" />
                      <path :fill="[
                        comment.company_comments__is_fixed
                          ? '#23B14D'
                          : 'rgba(49, 48, 61, 1)'
                      ]"
                        d="M12.9412 6.33209L10.0269 3.49247L9.27116 4.24721C9.16519 4.35317 9.16519 4.52498 9.27116 4.63094L9.84676 5.20654C9.95273 5.31251 9.95273 5.48431 9.84676 5.59027L7.83216 7.60488C7.72619 7.71084 7.55439 7.71084 7.44842 7.60488L6.86777 7.02422C6.84715 7.0036 6.82334 6.98644 6.79725 6.9734L6.16443 6.65699C6.05997 6.60475 5.9338 6.62523 5.85122 6.70781L5.43382 7.12521C5.32786 7.23117 5.32786 7.40298 5.43382 7.50894L8.88743 10.9625C8.99339 11.0685 9.16519 11.0685 9.27116 10.9625L9.68855 10.5452C9.77114 10.4626 9.79161 10.3364 9.73938 10.2319L9.42297 9.59912C9.40993 9.57303 9.39277 9.54922 9.37214 9.5286L8.79149 8.94794C8.68553 8.84198 8.68553 8.67018 8.79149 8.56421L10.8061 6.54961C10.9121 6.44364 11.0839 6.44364 11.1898 6.54961L11.7654 7.12521C11.8714 7.23117 12.0432 7.23117 12.1492 7.12521L12.9412 6.33209Z" />
                    </svg>
                  </div>
                  <div class="comment-actions__delete d-flex justify-content-center align-items-center cursor-pointer"
                    @click="delComment(comment.company_comments__id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M2.66983 1.70071C2.40222 1.4331 1.96833 1.4331 1.70071 1.70071C1.4331 1.96833 1.4331 2.40222 1.70071 2.66983L7.03088 8L1.70071 13.3302C1.4331 13.5978 1.4331 14.0317 1.70071 14.2993C1.96833 14.5669 2.40222 14.5669 2.66983 14.2993L8 8.96912L13.3301 14.2992C13.5977 14.5668 14.0316 14.5668 14.2992 14.2992C14.5668 14.0316 14.5668 13.5977 14.2992 13.3301L8.96912 8L14.2993 2.66983C14.5669 2.40222 14.5669 1.96833 14.2993 1.70071C14.0317 1.4331 13.5978 1.4331 13.3302 1.70071L8 7.03088L2.66983 1.70071Z"
                        fill="black" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BaseScrollbar>
      </div>
    </div>
    <div style="position: absolute; bottom: -45px; left: 0" v-if="!loadingsStateComponent.main">
      <BaseCheckboxV2 placeholder="" class="mb-10" input-name="companies__is_blocked_by_superadmin"
        v-model="checkLockAcess" signClass="fsc-10" @oncheckeds="updateValue">Доступ админу и всем сотрудникам
        заблокирован</BaseCheckboxV2>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import UploadFileWithPreview from '@/components/UploadFileWithPreview.vue'
import GeneralService from '@/api/GeneralService'
import SelectsService from '@/api/SelectsService.js'
import EventBus from '@/event-bus.js'
import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js'
import StorageFileService from '@/api/StorageFileService'
export default {
  components: {
    VueTabs,
    VTab,
    UploadFileWithPreview
  },

  props: {
    modalInfo: {
      type: Object
    }
  },
  data() {
    return {
      // v-model="companiesPlaces"
      //         :custom-label="
      //           ({ label }) => label
      //         "
      //         :options="listOptionsPlaces"
      listOptionsPlaces: [],
      checkLockAcess: false,
      companiesPlaces: [],
      listOptionsStatus: [],
      companiesStatus: [],
      selectTime: [],
      pincode: '',
      images: [],
      index: null,
      dataFromSelect: {
        orders__type_rent: [],
        ads: [],
        objects_types: [],
        orders__body_generation: [],
        loadingsStateComponent: [],
        cities__end_name: [],
        cities__start_name: [],
        sms_presets: [],
        client: []
      },
      dataFromSelect: {
        orders__type_rent: [],
        ads: [],
        objects_types: [],
        orders__body_generation: [],
        loadingsStateComponent: [],
        cities__end_name: [],
        cities__start_name: [],
        sms_presets: [],
        client: []
      },
      // modalInfo: {
      //   modalOpened: false,
      //   id: null,
      //   loading: true
      // },
      selectsOptions: {},
      senderSmsPreset: { sms_presets__text: '' },
      updatedValues: {},
      dataForTab: {},
      tabInfo: this.modalInfo,
      newCommentValue: {},
      messageError: [],
      someSmsToSend: '',

      loadingsStateComponent: {
        comment: false,
        deferred: false,
        main: false
      },

      commentsList: []
    }
  },
  methods: {
    checkDate(date) {
      if (date) {
        return date.split('-').reverse().join('.')
      } else {
        return ''
      }
    },

    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      if (Object.keys(this.updatedValues).length) {
        GeneralService.edit(
          `/super/companies/tab/info/${this.modalInfo.id}`,
          this.updatedValues
        )
          .then((data) => {
            this.$toast.success(data.data.message)
            EventBus.$emit('contentLoaded')
            EventBus.$emit('updateContentData')
            callback(true, nameTab, oldTab, newTab, flagIsClose)
          })
          .catch((e) => {
            if (e.response.status == 409) {
              this.messageError = e.response.data.message
              this.$toast.error(e.response.data.message, { duration: 5000 })
              callback(false, nameTab, oldTab, newTab)
            } else if (e.response.status >= 400) {
              // setTimeout(() => {
              //   Object.keys(e.response.data.errors).forEach((elem, index) => {
              //     if (this.$refs[elem]) {
              //       this.$refs[elem].classList.add('input-error')
              //     }
              //   })
              // }, 10)
              this.$toast.error(e.response.data.message, { duration: 5000 })
              callback(false, nameTab, oldTab, newTab)
            }
          })
      } else {
        EventBus.$emit('contentLoaded')
        EventBus.$emit('updateContentData')
        callback(true, '', oldTab, newTab, flagIsClose)
      }
    },
    sendSmsSome() {
      GeneralService.editOrCreate(`/notification?pincode=${this.pincode}`, {
        companyId: this.modalInfo.id,
        text: this.senderSmsPreset.sms_presets__text
      })
        .then((data) => {
          this.$toast.success(data.data.message)
          this.someSmsToSend = ''
          this.modalInfo.loading = false
          this.senderSmsPreset.sms_presets__text = ''
          EventBus.$emit('contentLoaded')
          EventBus.$emit('updateContentData')
          this.loadComments()
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message, { duration: 5000 })
          this.someSmsToSend = ''
        })
    },

    loadComments() {
      GeneralService.get(`/super/companies/table/comments/${this.modalInfo.id}`)
        .then((data) => {
          this.commentsList = data.data.data.rows.sort(
            (a, b) =>
              b.company_comments__is_fixed - a.company_comments__is_fixed
          )
          this.loadingsStateComponent.comment = false
        })
        .catch((e) => { })
    },
    delComment(id) {
      GeneralService.delete(
        `/super/companies/table/comments/${this.modalInfo.id}/${id}`
      )
        .then((data) => {
          // this.selects.push(data.data.data.rows)
          this.$toast.success(data.data.message)
          this.loadingsStateComponent.comment = false
          this.loadComments()
        })
        .catch((e) => { })
    },
    fixComment(id, fix) {
      GeneralService.edit(
        `/super/companies/table/comments/${this.modalInfo.id}/${id}`,
        {
          company_comments__is_fixed: fix
        }
      )
        .then((data) => {
          // this.selects.push(data.data.data.rows)
          this.$toast.success(data.data.message)
          this.loadingsStateComponent.comment = false
          this.loadComments()
          this.newCommentValue = {}
        })
        .catch((e) => { })
    },
    sendComment() {
      if (this.newCommentValue?.value) {
        this.loadingsStateComponent.comment = true
        GeneralService.editOrCreate(
          `/super/companies/table/comments/${this.modalInfo.id}`,
          {
            company_comments__comment: this.newCommentValue.value
          }
        )
          .then((data) => {
            // this.selects.push(data.data.data.rows)
            this.$toast.success(data.data.message)
            this.loadingsStateComponent.comment = false
            this.loadComments()
            this.newCommentValue = {}
            this.$refs.commentInput.$el.querySelector('input').value = ''
          })
          .catch((e) => { })
      } else {
        this.$toast.error('Напишите комментарий', { duration: 5000 })
      }
    },
    beforeClose() {
      this.updatedValues = {}
      this.dataForModal = {}
      this.modalInfo.modalOpened = false
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value

      if (data.name == 'companies__referer_koef' && !data.value.includes('.')) {
        let stringNew = data.value.split('').join('.')
        this.updatedValues[data.name] = stringNew
      }
      // if (this.$refs?.[data.name]) {
      //   this.$refs[data.name].classList.remove('input-error')
      // }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element['label'] = element[Object.keys(element).pop()]
          element['key'] = key
          element['value'] = Object.keys(element)[0]
          element['selectName'] = keyDataFromFetch
        })
      }
      return data
    },
    loadingMainInfo() {
      this.loadingsStateComponent.main = true
      Promise.all([
        GeneralService.get(`/super/companies/tab/info/${this.modalInfo.id}`)
          .then((data) => {
            this.dataForTab = data.data.data

            this.checkLockAcess = Boolean(
              data.data.data.companies__is_blocked_by_superadmin
            )
            console.log(data.data.data)
          })
          .catch((e) => { }),
        GeneralService.get(`/presets/sms`, {
          params: {
            where: JSON.stringify([
              { field: 'sms_presets__category_id', value: 2 }
            ])
          }
        })
          .then((data) => {
            Object.assign(this.selectsOptions, {
              presets: data.data.data.rows
            })
          })
          .catch((e) => { })
      ]).then(() => {
        this.companiesStatus = this.listOptionsStatus.find(
          (x) => x.value == this.dataForTab.companies__status
        )
        this.companiesPlaces = this.listOptionsPlaces.find(
          (x) => x.value == this.dataForTab.companies__is_place_any_city
        )

        EventBus.$emit('finishLoad')
        this.loadingsStateComponent.main = false
      })
    }
  },
  mounted() {
    this.listOptionsStatus = [
      {
        label: this.dataLang['company_status_not_requested'],
        value: 'company_status_not_requested'
      },
      {
        label: this.dataLang['company_status_requested'],
        value: 'company_status_requested'
      },
      {
        label: this.dataLang['company_status_confirmed'],
        value: 'company_status_confirmed'
      },
      {
        label: this.dataLang['company_status_rejected'],
        value: 'company_status_rejected'
      }
    ]

    this.listOptionsPlaces = [
      {
        label: this.dataLang['reg_company_103'],
        value: 0
      },
      {
        label: this.dataLang['reg_company_104'],
        value: 1
      }
    ]
  },
  created() {
    this.loadComments()
    this.loadingMainInfo()

    GeneralService.get(
      `/settings?fields=company_settings__set_security_pass_for_forbidden`
    )
      .then((data) => {
        this.pincode =
          data.data.data.rows[0].company_settings__set_security_pass_for_forbidden
      })
      .catch((e) => { })
  },
  computed: {
    ...mapState('translationModule', ['dataLang']),
    ...mapState('userSettingModule', ['userSetting'])
  }
}
</script>
